import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontPoppins } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";

export const Container = styled.div`
  display: flex;
`;

type StyledBaseLinkProps = {
  $isActive?: boolean;
};

export const StyledBaseLink = styled(BaseLink)<StyledBaseLinkProps>`
  display: block;

  ${props =>
    props.$isActive
      ? css`
          font-weight: 900;
        `
      : null}
`;

export const MenuItemName = styled.span`
  color: #555555;
  font-size: 18px;
  font-family: ${fontPoppins};
  line-height: 140%;
  text-transform: uppercase;
`;

export const SubMenu = styled.div`
  position: absolute;

  display: none;

  border: 1px solid #555555;

  background: #ffffff;
`;

export const SubMenuItem = styled(StyledBaseLink)`
  padding-block: 10px;
  padding-inline: 16px;

  white-space: nowrap;
  &:not(:last-child) {
    border-block-end: 1px solid #555555;
  }
`;

export const MenuItem = styled.div`
  position: relative;
  &:hover {
    ${SubMenu} {
      display: block;
    }
  }
  &:not(:last-child) {
    margin-inline-end: 38px;
  }
`;
